import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu-filter"
export default class extends Controller {
  static targets = ["menu"];

  toggle(event) {
    event.stopPropagation();
    this.closeAll();
    this.menuTarget.classList.toggle("hidden");
  }

  close(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.add("hidden");
    }
  }

  closeAll() {
    document.querySelectorAll('[role=menu]').forEach(menu => {
      if (menu !== this.menuTarget) {
        menu.classList.add("hidden");
      }
    });
  }
}
